<template lang="pug">
  ods-dialog(
    :title='$t("profile.password.change_password")'
    width="30%"
    :append-to-body="true"
    :visible.sync="showDialogPass"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @open="openDialogChangePass"
  )
    section
      article
        p {{ $t("profile.password.change_first_password") }}
        br
      article
        ods-form.the-b2b-change-password(
          ref='changePasswordForm',
          :model='form',
          :rules='rules',
          size='mini')
          ods-form-item(
            ref='formItemOldPass'
            :label='$t("profile.password.change_password_form.old_password.label")'
            prop='oldpassword')
            ods-input(
              v-model='form.oldpassword'
              show-password
              type='password'
              :placeholder='$t("profile.password.change_password_form.old_password.placeholder")'
              @input='passwordFormHasChanged' auto-complete='off')

          ods-form-item(
            ref='formItemNewPass'
            :label='$t("profile.password.change_password_form.new_password.label")'
            style='padding-top: 15px'
            prop='newpassword')
            ods-input(
              v-model='form.newpassword'
              show-password
              type='password'
              :placeholder='$t("profile.password.change_password_form.new_password.placeholder")'
              @input='passwordFormHasChanged' auto-complete='off')
          ods-form-item(
            ref='formItemRepeatNewPass'
            :label='$t("profile.password.change_password_form.confirm_password.label")'
            style='padding-top: 15px'
            prop='repeatnewpassword'
            class="ods-mb-10")
            ods-input(
              v-model='form.repeatnewpassword'
              show-password
              type='password'
              :placeholder='$t("profile.password.change_password_form.confirm_password.placeholder")'
              @input='passwordFormHasChanged'
              auto-complete='off')
        div.the-b2b-change-password__actions
          ods-button(v-if='!hideCancelButton' type='neutral' @click='resetForm()')
            | {{ $t('buttons.btnClear') }}
          ods-button(type='primary' @click='savePassword' round :disabled='saveButtonDisabled').is-shadow
            | {{ $t('buttons.btnSaveChanges') }}</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Util from '@/components/shared/Utils'

export default {
  name: 'ChangePassworduserDialog',
  mixins: [Util],
  props: ['showDialog'],
  data () {
    return {
      susername: null,
      urlUser: null,
      saveButtonDisabled: true,
      hideCancelButton: true,
      showDialogPass: false,
      form: {
        oldpassword: null,
        newpassword: null,
        repeatnewpassword: null
      },
      rules: {
        oldpassword: [
          {
            validator: (rule, value, callback) => {
              if (
                ((this.form.newpassword && this.form.newpassword !== '') ||
                  (this.form.repeatnewpassword &&
                    this.form.repeatnewpassword !== '')) &&
                (!value)
              ) {
                callback(
                  new Error(this.$t('msg_generics.field_required'))
                )
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        newpassword: [
          {
            validator: (rule, value, callback) => {
              if (
                ((this.form.oldpassword && this.form.oldpassword !== '') ||
                  (this.form.repeatnewpassword &&
                    this.form.repeatnewpassword !== '')) &&
                (!value)
              ) {
                callback(
                  new Error(this.$t('msg_generics.field_required'))
                )
              } else {
                callback()
              }
            },
            trigger: 'change'
          },
          {
            min: 10,
            message: this.$t('msg_generics.min_num_character', { min: 10 }),
            trigger: 'change'
          },
          {
            max: 64,
            message: this.$t('msg_generics.max_num_character', { max: 64 }),
            trigger: 'change'
          },
          {
            pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#\$%\^&\*_=\+-/])[A-Za-z\d!@#\$%\^&\*_=\+-/]{10,64}$/, // eslint-disable-line
            message: this.$t('profile.password.rules_form.pattern'),
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              if (value && value === this.form.oldpassword) {
                callback(
                  new Error(this.$t('profile.password.rules_form.pass_eqaul_newpass'))
                )
              } else {
                callback()
              }
            },
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              if (value && value != '') { // eslint-disable-line
                const forbiddenWords = [
                  '01234587',
                  '12345679',
                  'Xxxxxxxxx',
                  'Yyyyyyyyy',
                  'Password',
                  'Administrador',
                  'Administ',
                  '00000000',
                  '11111111'
                ]
                if (forbiddenWords.includes(value)) {
                  callback(
                    new Error(this.$t('profile.password.rules_form.fobidden_words'))
                  )
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              if (value && value != '' && value === this.username) { // eslint-disable-line
                callback(
                  new Error(this.$t('profile.password.rules_form.pass_equal_user'))
                )
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        repeatnewpassword: [
          {
            validator: (rule, value, callback) => {
              if (
                ((this.form.oldpassword && this.form.oldpassword !== '') ||
                  (this.form.newpassword &&
                    this.form.newpassword !== '')) &&
                (!value)
              ) {
                callback(
                  new Error(this.$t('msg_generics.field_required'))
                )
              } else {
                callback()
              }
            },
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              if (value && value !== this.form.newpassword) {
                callback(new Error(this.$t('profile.password.rules_form.newpass_not_equals_confirmation')))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['urlIn'])
  },
  methods: {
    ...mapActions([
      'modifyPassword'
    ]),
    passwordFormHasChanged () {
      if (
        !this.form.oldpassword &&
        !this.form.newpassword &&
        !this.form.repeatnewpassword
      ) {
        delete this.$refs.changePasswordForm.rules.oldpassword
        this.$refs.formItemOldPass.resetField()
        delete this.$refs.changePasswordForm.rules.newpassword
        this.$refs.formItemNewPass.resetField()
        delete this.$refs.changePasswordForm.rules.repeatnewpassword
        this.$refs.formItemRepeatNewPass.resetField()
      } else {
        this.$refs.changePasswordForm.rules.oldpassword = this.rules.oldpassword
        this.$refs.changePasswordForm.rules.newpassword = this.rules.newpassword
        this.$refs.changePasswordForm.rules.repeatnewpassword = this.rules.repeatnewpassword
        this.$refs.changePasswordForm.validate().catch(error => false) // eslint-disable-line
      }
      this.formHasChanged()
    },

    formHasChanged () {
      const dirty =
        !!(this.form.oldpassword ||
        this.form.newpassword ||
        this.form.repeatnewpassword)
      this.saveButtonDisabled = !dirty
      this.hideCancelButton = !dirty
    },
    clearFormData () {
      this.form.oldpassword = null
      this.form.newpassword = null
      this.form.repeatnewpassword = null
    },

    async resetForm () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        this.$refs.changePasswordForm.resetFields()
        delete this.$refs.changePasswordForm.rules.oldpassword
        delete this.$refs.changePasswordForm.rules.newpassword
        delete this.$refs.changePasswordForm.rules.repeatnewpassword
        this.saveButtonDisabled = true
        this.hideCancelButton = true
      } finally {
        load.close()
      }
    },

    async savePassword () {
      this.passwordFormHasChanged()
      const formValid = await this.$refs.changePasswordForm
        .validate()
        .catch(error => false) // eslint-disable-line
      if (!formValid) {
        this.$notify({
          title: this.$t('profile.password.rules_form.validation_error'),
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 10000
        })
        return
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const params = {}
        if (
          this.form.newpassword ||
          this.form.oldpassword ||
          this.form.repeatnewpassword
        ) {
          params.password = {
            newPassword: this.form.newpassword,
            oldPassword: this.form.oldpassword,
            repeatNewPassword: this.form.repeatnewpassword
          }
        }
        await this.modifyPassword(params)
        this.$notify({
          title: this.$t('profile.notify.changes_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
        this.resetForm()
        this.showDialogPass = false
        console.log('showDialog', this.showDialog)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    openDialogChangePass () {
      this.form.oldpassword = ''
      this.form.newpassword = ''
      this.form.repeatnewpassword = ''
      if (this.$refs.changePasswordForm) {
        this.$refs.changePasswordForm.clearValidate()
      }
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 404:
        case 409:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },
  async created () {
    this.username = this.$store.getters.activeUser.data.username
    this.urlUser = this.$route.params.urlIn
    this.showDialogPass = this.showDialog

    console.log('this.username: ', this.username)

    this.clearFormData()
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      if (this.$refs.changePasswordForm) {
        this.$refs.changePasswordForm.clearValidate()
      }
    } catch (error) {
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
